var companyNewsToRows = function (companyNews) {
    var xposArr = [];
    companyNews.map(function (c) {
        if (!xposArr.includes(c.xpos)) {
            xposArr.push(c.xpos);
        }
    });
    return xposArr.sort().map(function (i) {
        return companyNews.filter(function (c) { return c.xpos === i; });
    });
};
export default companyNewsToRows;
